import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { GET_EXPENSE } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import TableLayout from '../layout/TableLayout';
import FormLayout from '../layout/FormLayout';

export default function ExpensesList() {

     const [list, setList] = useState([]);

     const tableHeaders = ['#', 'date', 'doc_no', 'vendor', 'item_name', 'amount', 'action'];

     const keys = ["date", "e_number", "full_name", "item_name", "total", "btnEdit"];

     const btnData = {
          btnEdit: {
               name: "View", link: "/root/expense/view"
          }
     }

     useEffect(() => {
          getExpenses();
     }, []);

     const getExpenses = async (payload = {}) => {
          const res = await httpClient.post(GET_EXPENSE, payload);
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setList(result.data);
               }
          }
     }

     const [formData, setFormData] = useState({
          formTitle: 'Search Customer',
          formFields: [
               { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-2" },
               { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-2" },
               { label: 'vendor', id: 'vendor', type: 'text', name: 'name', value: '', className: "col-md-3", placeholder: 'Enter name' },
               { label: 'number', id: 'number', type: 'text', name: 'number', value: '', className: "col-md-3", placeholder: 'Enter number' },
          ],
          formErrors: { from_date: '', to_date: '', name: '', number: '' },
     });

     const handleFieldChange = (fieldName, value) => {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     const handleFieldBlur = () => { }

     const handleSubmit = (e) => {
          e.preventDefault();
          let post = {};
          const updatedFormFields = formData.formFields.map((field) => {
               post[field.name] = field.value;
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          getExpenses(post);
     }
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="expenses" newButton="new" newButtonLink="root/expense/new" />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <FormLayout
                                        formTitle={formData.formTitle}
                                        formFields={formData.formFields}
                                        formErrors={formData.formErrors}
                                        onFieldChange={handleFieldChange}
                                        onFieldBlur={handleFieldBlur}
                                        onSubmit={handleSubmit}
                                        isModal
                                        search
                                   />
                                   <TableLayout
                                        headers={tableHeaders}
                                        keys={keys}
                                        tableData={list}
                                        id="id"
                                        btnData={btnData}
                                        numberKey={["total"]}
                                   />  </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
